/**
 * Returns a structural deep clone of any JSON-serializable value via the
 * stringify/parse round-trip. Handy when we need a snapshot that is
 * fully decoupled from the source object — controllers use it to
 * preserve original payloads for change-detection / cancel flows.
 *
 * Caveats: drops `undefined`, functions, `Date`, `Map`/`Set` and any
 * other non-JSON value. If you need to clone those, reach for
 * `structuredClone` instead.
 *
 * @template T
 * @param {T} value
 * @returns {T}
 */
export function clone(value) {
    if (value === undefined || value === null) return value;
    return JSON.parse(JSON.stringify(value));
}

